// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1G9Vw","right":"Footer_right__QutlD","buttons":"Footer_buttons__2MVvR"};